import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const MessageIcon = ({
  width = 48,
  marginRight,
  marginLeft,
  color = 'foraBlue',
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
      <path
        fill={getSemanticTextColor(color)}
        fillRule="evenodd"
        d="M35.986 14.108c2.368-1.477 5.368-1.477 7.741 0l25.826 16.096c1.964 1.229 3.155 3.343 3.155 5.617v31.471c0 3.68-3.062 6.663-6.845 6.663H13.846c-3.78 0-6.846-2.982-6.846-6.663v-31.47c0-2.275 1.19-4.39 3.156-5.618zM60.55 32.173H19.158c-2.776 0-3.925 3.456-1.683 5.04l20.264 14.353c1.271.896 2.964.896 4.23 0l20.27-14.352c2.24-1.585 1.087-5.04-1.689-5.04zM47.125 36.25c1.467 0 2.658 1.19 2.658 2.663 0 1.472-1.19 2.663-2.658 2.663H32.918c-1.477 0-2.668-1.19-2.668-2.663 0-1.472 1.19-2.663 2.668-2.663z"
      />
    </svg>
  </DefaultIconWrapper>
);
